import { TipoTipologica } from "./tipo-tipologica";

export class SpesaLegale {
  id: string;
  dataInizioCalcoloInteressi: number;
  tipoGiudizio: TipoTipologica;
  grado: TipoTipologica;
  interessiLegali: number;
  importo: number;
}
